import React from 'react'

import AppRoutes from 'utils/routes/AppRoutes'

import { NotificationPopup } from 'components/NotificationPopup'

const App = () => {
  return (
    <>
      <NotificationPopup />
      <AppRoutes />
    </>
  )
}

export default App
